// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@/PayPlans/views/Layers/Departments/Managers/Sales";

const POSITION = "General Sales Manager";

export default function GeneralManagers() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"General Sales Managers Pay Plans"} icon={Icon}>
			<Layer position={POSITION} />
		</PageLayer>
	);
}
